import { render } from "./PedidoDetLOV.vue?vue&type=template&id=35a1bc5f"
import script from "./PedidoDetLOV.vue?vue&type=script&lang=js"
export * from "./PedidoDetLOV.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__